export default class PayForBookingsWithUserSubscriptionRequestData {
  public booking_ids: Array<number>
  public user_subscription_id: number

  public constructor (bookingIds: Array<number>, userSubscriptionId: number) {
    this.booking_ids = bookingIds
    this.user_subscription_id = userSubscriptionId
  }
}
